import { computed, ref, unref, watch } from 'vue';

/**
 * Client-side list pagination for frontoffice index blocks.
 * Pair with FrontofficeListPagination via v-model:current-page.
 */
export function useClientPagination(itemsSource, perPage, options = {}) {
  const {
    resetWatchSources = [],
  } = options;

  const currentPage = ref(1);

  const itemCount = computed(() => {
    const items = unref(itemsSource);
    return Array.isArray(items) ? items.length : 0;
  });

  const totalPages = computed(() => (
    Math.max(1, Math.ceil(itemCount.value / perPage))
  ));

  const paginatedItems = computed(() => {
    const items = unref(itemsSource) ?? [];
    const start = (currentPage.value - 1) * perPage;
    return items.slice(start, start + perPage);
  });

  function resetPage() {
    currentPage.value = 1;
  }

  function clampPage() {
    if (currentPage.value > totalPages.value) {
      currentPage.value = totalPages.value;
    }
    if (currentPage.value < 1) {
      currentPage.value = 1;
    }
  }

  resetWatchSources.forEach((source) => {
    watch(source, resetPage);
  });

  watch(itemCount, clampPage);

  return {
    currentPage,
    totalPages,
    paginatedItems,
    resetPage,
  };
}
